import { Pipe, PipeTransform } from '@angular/core';
import { getAvatarColor, getContrastTextColor } from 'src/app/common/avatarColorUtils';

/**
 * Pipe to generate avatar style object with background and text color
 * Usage: [style]="userName | avatarStyle"
 */
@Pipe({
  name: 'avatarStyle',
  standalone: true,
})
export class AvatarStylePipe implements PipeTransform {
  transform(identifier: string): { 'background-color': string; color: string } {
    const bgColor = getAvatarColor(identifier);
    const textColor = getContrastTextColor(bgColor);
    return {
      'background-color': bgColor,
      color: textColor,
    };
  }
}
